

import dayjs from "dayjs";
import { IGetAllTreinamentoFuncionarioTercLocalUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_terc_local_use_case";
import { TreinamentoFuncionarioLocal } from "../../../../rh/domain/models/treinamento_funcionario_local";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


export class GetAllTreinamentoFuncionarioTercLocalUseCase implements IGetAllTreinamentoFuncionarioTercLocalUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async getAllTreinamentoFuncionarioTercLocal(
    data: Date,
    instrutor: string,
  ): Promise<TreinamentoFuncionarioLocal[]> {
    return await this.repository
      .getAllTreinamentoFuncionarioTercLocal(dayjs(data).format('YYYYMMDD'), instrutor);
  }
}
